// extracted by mini-css-extract-plugin
var _1 = "AccountConnected-module__container___Dw2E5";
var _2 = "AccountConnected-module__link___SYRgp";
var _3 = "AccountConnected-module__text___ppMYn";
export { _1 as "container", _2 as "link", _3 as "text" }
